;(function( $, window, document, undefined ){
	$.fn.doubleTapToGo = function( params ){
		if( !( 'ontouchstart' in window ) &&
			!navigator.msMaxTouchPoints &&
			!navigator.userAgent.toLowerCase().match( /windows phone os 7/i ) ) return false;

		this.each( function(){
			var curItem = false;
			$( this ).on( 'click', function( e ){
				var item = $( this );
				if( item[ 0 ] != curItem[ 0 ] )
				{
					e.preventDefault();
					curItem = item;
				}
			});

			$( document ).on( 'click touchstart MSPointerDown', function( e ){
				var resetItem = true,
					parents	  = $( e.target ).parents();

				for( var i = 0; i < parents.length; i++ )
					if( parents[ i ] == curItem[ 0 ] )
						resetItem = false;

				if( resetItem )
					curItem = false;
			});
		});
		return this;
	};
})( jQuery, window, document );

(function($) {

	function parallax(height) {
	"use strict";
		var scrollPosition = $(window).scrollTop();
		var scrollOffset = scrollPosition * 0.1;
		if(scrollOffset < 0){
			scrollOffset = 0;
		}
	var bannerOffset = $('#header').position();
	bannerOffset = bannerOffset.top / 10;
	var calcImageHeight = (height + bannerOffset);
		$('#header .image-layer').css({
		'transform':'translatey(' + scrollOffset + 'px)',
		'top': -bannerOffset + 'px',
		'height': calcImageHeight + 'px'
	});
	}

	function mobileNav(){
	"use strict";
	var toggled = false;
	$('.mobile-navigation-toggle').click(function(e){
		e.preventDefault();
		if (!toggled){
		toggled = true;
		$('#mobile-navigation').addClass('toggled');
		} else {
		toggled = false;
		$('#mobile-navigation').removeClass('toggled');
		}
	});
		$(window).resize(function(){
			var width = $(window).width();
			if (width > 768){
				toggled = false;
			$('#mobile-navigation').removeClass('toggled');
			}
	});
	}

	function svgPadding(){
		$('.svg-image svg').each(function() {
		var svg = $(this);
		var viewBox = svg.attr('viewBox');
		var viewBoxArray = viewBox.split(' ');
		var aspectRatio = (viewBoxArray[3] / viewBoxArray[2]) * 100;
		$(this).parent().css('padding-bottom', aspectRatio + '%');
	});
	}

	function homeScripts(){
		$('.circle-layer').css('width', $('.circle-layer').outerHeight());
		$('.news-slider').slick({
	arrows: true ,
		prevArrow: '',
		nextArrow: '<a href="#" class="slick-next" role="button"><span>Next</span></a>',
		autoplay: true,
		autoplaySpeed: 4000,
		swipe: false,
		touchMove: false,
		draggable: false
		});
		$('.information-slider').slick({
	arrows: false, autoplay: false, swipe: false, touchMove: false, draggable: false, accessibility: false
		});
		$('a[data-information-number]').click(function(e) {
			e.preventDefault();
			var number = $(this).data('university-number');
			$('.information-slider').slick('slickGoTo', number - 1);
			$('a[data-information-number]').removeClass('active');
			$(this).addClass('active');
		});
	}

	$(document).ready(function(){
		svgPadding();
	mobileNav();
	$('#mobile-navigation ul.nav li:has(ul)' ).doubleTapToGo();
		$('#main-navigation ul.nav li:has(ul)' ).doubleTapToGo();
		if($('body').hasClass('page-template-page-home')){
			homeScripts();
		}
	});

	$(window).resize(function(){
	parallax($('#header').outerHeight());
		if($('body').hasClass('page-template-page-home')){
			$('.circle-layer').css('width', $('.circle-layer').outerHeight());
		}
	});

	$(document).scroll(function(){
	parallax();
	});

	$(window).on('load', function(){
		$('#template').addClass('loaded');
		parallax($('#header').outerHeight());
	});

})(jQuery);